import * as React from 'react'

import {
    Stack,
    List,
    ListItemButton,
    ListItemIcon,
    ListSubheader,
    Box,
    Avatar,
    ListItem,
    useMediaQuery
} from '@mui/material'
import { Logout } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import Carousel from 'react-material-ui-carousel'
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';

import Anima from '../../../../assets/images/logosDepoimento/logo-anima-1024.png';
import NovosConceitos from '../../../../assets/images/logosDepoimento/novos_conceitos.png';
import LZ from '../../../../assets/images/logosDepoimento/LZ.png';
import ProBrasil from '../../../../assets/images/logosDepoimento/pro.png';
import RadioLiberdade from '../../../../assets/images/logosDepoimento/Logo-liberdade-radio-Belo-Horizonte.png';


import { Navigation, Pagination, Scrollbar, A11y, Autoplay  } from 'swiper/modules';

import { Swiper, SwiperSlide } from 'swiper/react';

import { ItemText } from '../../../itemText';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { BaseDiv, CardBody, CardContent, CardLogo, CardName, PrincipalDiv } from './styles'

interface INavBar {

}



const CarrouselClientesFalam: React.FC<INavBar> = () => {
    const navigate = useNavigate();
    const matches = useMediaQuery('(max-width:1000px)');
    const matches2 = useMediaQuery('(max-width:1300px)');
    const matches3 = useMediaQuery('(max-width:1600px)');
    const matches4 = useMediaQuery('(max-width:1400px)');
    const matchesSwipe = useMediaQuery('(max-width:900px)');
    const mobileMatch = useMediaQuery('(max-width:450px)');


    const dados = [
        {
            logo: Anima,
            content:"Mídia em ônibus nos traz o impacto de um grande formato com a vantagem de uma cobertura maior. A capilaridade que as linhas entregam ampliam a cobertura de campanha para dentro dos bairros e regiões onde não temos opções OOH. Sem falar da possibilidade de escolher linhas e definir o público a ser impactado, segmentado por regiões. É sem dúvida o meio, dentro do leque de meios de OOH, que traz maior impacto e cobertura.",
            content2:"Por sua vez, a BHBUS Mídia entrega profissionalismo e excelência na execução da mídia. Tenho plena confiança quando me orientam na seleção das linhas e também quando envio a arte para produção. ",
            name:"Dani Carvalho - Grupo Ânima"
        },
        {
            logo: NovosConceitos,
            content:"O Backbus está sempre presente em nossos planejamentos e ações de mídias para divulgação das campanhas, produtos e serviços de nossos clientes. O custo-benefício, a garantia da mensagem entregue para nosso público alvo em cada cantinho de BH, a excelência do atendimento e parceria com a BHBUS Mídia, são os ingredientes e garantia de sucesso dessa receita. ",
            name:"José Afonso Júnior - Novos conceitos"
        },
        {
            logo: LZ,
            content:"A mídia ônibus, BACKBUS é uma mídia de grande impacto, na minha percepção, ideal para campanhas pontuais, como matrículas e lançamentos.",
            content2:"Existe uma percepção “equivocada” de que a mídia ônibus é popular. Uma coisa é ser popular e outra é ser abrangente. Nesse caso, a mídia ônibus é “abrangente“ ou seja atinge todo tipo de público que está nas ruas. O que vai definir a qual público ela está direcionada, será o tom e a linguagem de comunicação. Uma linguagem dirigida a um público AB na mídia ônibus não irá impactar o público CD, e vice-versa. Na categoria OOH a mídia em ônibus é a mídia de maior impacto e visibilidade.",
            name:"Mazzarele - LZ "
        },
        {
            logo: ProBrasil,
            content:"A mídia ônibus é um dos meios de comunicação de maior impacto e alcance de público de Belo Horizonte. ",
            content2:"Sempre utilizamos backbus nas nossas estratégias de mídia para os mais diversos segmentos de clientes e a visibilidade das campanhas é sempre excelente. A BHBUS Mídia executa um excelente trabalho de manutenção das mídias.",
            name:"Síria - Pró Brasil"
        },
        {
            logo: RadioLiberdade,
            content:"A BHBUS Mídia é uma empresa com a qual eu sempre negocio para as nossas campanhas, em parceria com a equipe, escolhemos linhas estratégicas para eficácia da campanha.",
            content2:"Sempre contemplo a mídia em ônibus em nossos planos de mídia, considero um meio de excelente custo benefício e alcance.",
            name:"Juliana- Rádio Liberdade"
        },
    ]

    return (
        <BaseDiv id="dep">
          <PrincipalDiv>
            <h1
              style={{
                fontSize: matches ? '20px' : matches3 ? '26px' : '36px',
                color: 'white',
                paddingBottom: '30px',
                margin: 0,
              }}
              className='clientesTitle'
            >
              O QUE FALAM NOSSOS CLIENTES
            </h1>
            <Swiper
              modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
              spaceBetween={15}
              slidesPerView={matchesSwipe ? 1 : matches2 ? 2 : matches3 ? 3 : 4}
              pagination={{
                clickable: true,
              }}
              autoplay={{
                delay: 1500, // 3 seconds delay between slides
                disableOnInteraction: true, // Auto-play continues even after user interaction
              }}
              style={{
                display: 'flex',
                textAlign: 'center',
                maxWidth: '100%',
                height: mobileMatch
                  ? '530px'
                  : matches
                  ? '450px'
                  : matches2
                  ? '420px'
                  : matches4
                  ? '470px'
                  : '500px',
              }}
            >
              {dados.map((data: any, index: number) => (
                <SwiperSlide key={index}>
                  <CardBody>
                    <CardLogo>
                      <img
                        src={data?.logo}
                        width={mobileMatch ? 70 : matches ? 80 : 100}
                        style={{ maxHeight: mobileMatch ? 50 : matches ? 60 : 75 }}
                      />
                    </CardLogo>
                    <CardContent>
                      <p>
                        <FormatQuoteIcon
                          style={{
                            display: 'flex',
                            justifyContent: 'left',
                            transform: 'rotateY(180deg)',
                            marginLeft: '5px',
                          }}
                        />
                        {data?.content}
                      </p>
                      <p>
                        {data?.content2}
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'right',
                            marginRight: '6px',
                            marginTop: '-3px',
                          }}
                        >
                          <FormatQuoteIcon />
                        </div>
                      </p>
                    </CardContent>
                    <CardName>{data?.name}</CardName>
                  </CardBody>
                </SwiperSlide>
              ))}
            </Swiper>
          </PrincipalDiv>
        </BaseDiv>
      );
    };

export { CarrouselClientesFalam }